import { FormattedMessage, useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { Item } from 'react-stately';
import ListBox from '../ListBox/ListBox';
import Popover from 'client/components/aria/Popover/Popover';
import Icon from '@mdi/react';
import { mdiHelpCircle } from '@mdi/js';
import styles from './CoverageAssetOwners.module.scss';
import LegendItem from 'client/pages/MapPage/components/Legend/LegendItem/LegendItem';
import { operationalAreaStyling } from 'client/pages/MapPage/layers/styles/networkCoverageStyle';
import { selectMyCoverage } from 'client/store/coverageAssetOwnersSlice/coverageAssetOwnersSlice';

const CoverageAssetOwners = () => {
    const intl = useIntl();
    const assetOwners = useSelector(state => state.coverageAssetOwners.assetOwners);
    const myCoverage = useSelector(selectMyCoverage, shallowEqual);
    const assetOwnersArray = Object.values(assetOwners);

    return (
        <div>
            <div>
                <h3 className={styles.heading} data-testid="coverageAssetOwners.myCoverageArea">
                    <FormattedMessage id="coverageAssetOwners.myCoverageArea"/>
                    <div >
                        <Popover aria-label={intl.formatMessage({ id: 'general.help' })} content={
                            <p className="govuk-body-s govuk-!-font-size-14">
                                <FormattedMessage id="coverageAssetOwners.help.myCoverageArea"/>
                            </p>
                        }>
                            <Icon path={mdiHelpCircle} size={1.1} className={styles.help}/>
                        </Popover>
                    </div>
                </h3>
                <LegendItem prefix={operationalAreaStyling} className={styles.prefix}>
                    <p data-testid="coverageAssetOwners.myCoverageArea.name" className={styles.paragraph} > {myCoverage.organisationDisplayName}</p>
                </LegendItem>
            </div>
            <div>
                <h3 className={styles.heading} id="coverageAssetOwners.otherAssetOwners" data-testid="coverageAssetOwners.otherAssetOwners.heading">
                    <FormattedMessage id="coverageAssetOwners.otherAssetOwners"/>
                    <div >
                        <Popover aria-label={intl.formatMessage({ id: 'general.help' })} content={
                            <p className="govuk-body-s govuk-!-font-size-14">
                                <FormattedMessage id="coverageAssetOwners.help.otherAssetOwners"/>
                            </p>
                        }>
                            <Icon path={mdiHelpCircle} size={1.1} className={styles.help}/>
                        </Popover>
                    </div>
                </h3>
                <ListBox
                    className={styles.listBox}
                    data-testid={'coverageAssetOwners.otherAssetOwners'}
                    aria-labelledby={'coverageAssetOwners.otherAssetOwners'}
                >
                    {assetOwnersArray.map(owner => {
                        return <Item key={owner.systemId} data-testid={`assetOwner_${owner.systemId}`} textValue={owner.displayName}>
                            <div className="govuk-!-padding-2">
                                <p className="govuk-heading-xs govuk-!-margin-0 govuk-!-font-weight-bold">{owner.displayName}</p>
                            </div>
                        </Item>;
                    })}
                </ListBox>
            </div>
        </div>
    );
};

export default CoverageAssetOwners;
